import api from "./index";

export interface ActListParams {
  number?: string;
  companyId?: string;
  contractId?: string;
  responsibleId?: string;
  contractorId?: string;
  contractorType?: "juridical" | "physical";
  isSignedAt?: boolean;
  priceMin?: number;
  priceMax?: number;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  formedAtMin?: Date;
  formedAtMax?: Date;
  signedAtMin?: Date;
  signedAtMax?: Date;
  isArchive?: boolean;
  archivedAtMin?: Date;
  archivedAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "createdAt" | "updatedAt" | "formedAt" | "number";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: ActListParams, options?: any) => {
  return api.ActApi.listShort(
    params.number,
    params.companyId,
    params.contractId,
    params.responsibleId,
    params.contractorId,
    params.contractorType,
    params.isSignedAt,
    params.priceMin,
    params.priceMax,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.formedAtMin,
    params.formedAtMax,
    params.signedAtMin,
    params.signedAtMax,
    params.isArchive,
    params.archivedAtMin,
    params.archivedAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    options
  );
};
